import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Navbar from "../../Navbar/Navbar.js";
import Framework from "../../../Images/frameworks.svg";
import Footer from "../../Footer/Footer.js";
import DetailsCard from "./DetailsCard.js";
import cardData from "../../../resources/cardData.json";
import logoTextData from "../../../resources/logoTextData.json";
import imageHeader from "../../../resources/imageHeader.json";
import SubHeadings from "./SubHeadings.js";
import ImageHeader from "./ImageHeader.js";
import SliderPage from "./SliderPage.js";
import framework from "../../../Images/ApplicationFrame.jpg";
import { ReactComponent as Lock } from "../../../Images/shield-lock.svg";
import { ReactComponent as SeamlessUser } from "../../../Images/person-video3.svg";
import { ReactComponent as Migration } from "../../../Images/shuffle.svg";
import { ReactComponent as Roles } from "../../../Images/person-gear.svg";
import { ReactComponent as PassKey } from "../../../Images/key.svg";
import { ReactComponent as APIs } from "../../../Images/database-gear.svg";
import { ReactComponent as SelfService } from "../../../Images/person-gear.svg";
import { ReactComponent as Recycle } from "../../../Images/recycle.svg";
import { ReactComponent as Analytics } from "../../../Images/bar-chart-line.svg";
import { ReactComponent as Multichannel } from "../../../Images/bezier2.svg";
import { ReactComponent as Scalability } from "../../../Images/graph-up-arrow.svg";
import { ReactComponent as JSON } from "../../../Images/filetype-json.svg";
import { ReactComponent as SignOn } from "../../../Images/ui-checks.svg";
import { ReactComponent as MultiLanguage } from "../../../Images/translate.svg";
import { ReactComponent as SearchEngineOptimization } from "../../../Images/searchEngin.svg";
import { ReactComponent as LogError } from "../../../Images/send-x.svg";
import Header, {
  NavLink,
  NavLinks,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../../Navbar/Navbar.js";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./BreadCrumbs.js";
import ContactUsButton from "./ContactUsButton.js";
import IconCard from "./IconCard.js";
import CIAMLogoCard from "./CIAMLogoCard.js";
import { ReactComponent as Fingerprint } from "../../../Images/fingerprint.svg";
import { ReactComponent as Signup } from "feather-icons/dist/icons/log-in.svg";
import { ReactComponent as Sso } from "../../../Images/file-earmark-lock.svg";
import { ReactComponent as Mfa } from "../../../Images/building-lock.svg";
import { ReactComponent as Amazon } from "../../../Images/amazon.svg";
import { ReactComponent as Mobile } from "../../../Images/tablet.svg";
import { ReactComponent as EmailCheck } from "../../../Images/envelope-check.svg";
import { ReactComponent as DataEfficient } from "../../../Images/database-fill-check.svg";
import { ReactComponent as Cache } from "../../../Images/stack.svg";
import TechStack1 from "./TechStack1.js";

const ThreeColumnContainer = styled.div`
  ${tw`mt-1 flex flex-col items-center lg:items-stretch lg:flex-row  md:flex-row md:items-stretch md:justify-center sm:flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;
const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none text-gray-800 bg-white z-10`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-pink-700 opacity-25`;
const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-2xl mx-auto`;
const ContainerNav = styled.div`
  ${tw`relative`}
`;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-10`;
const Description = tw.p`px-6 font-semibold py-2  text-xl text-gray-900 text-justify`;
const imgStyle = { width: "40px", height: "40px" };
const Card = styled.div`
  ${tw`flex items-center   text-center h-full lg:w-1/2  md:px-10 px-2 pb-5`}
  .imageContainer {
    ${tw` items-start mt-3 rounded-full text-red-500  flex-shrink-0`}
    .image {
      ${tw`w-10 h-10 `}
    }
  }

  .textContainer {
    ${tw`mt-4 ml-2`}
  }

  .textContainerr {
    ${tw`mt-2 ml-1`}
  }

  .title {
    ${tw`mt-4  text-blue-900 font-bold  pb-1  text-lg  h-5`}
  }

  .titlee {
    ${tw`mt-2  text-blue-900 font-semibold  pb-1  text-lg  h-3`}
  }

  .description {
    ${tw`mt-4 text-justify px-5  md:text-justify  sm:text-justify leading-relaxed`}
    font-size: 16px;
  }

  .descriptionn {
    ${tw`text-justify px-2  md:text-justify  sm:text-justify leading-relaxed`}
    font-size: 14px;
  }

  .link {
    ${tw`mt-auto inline-flex items-center  justify-end w-full text-sm font-bold text-blue-700 leading-none hocus:text-primary-900 transition duration-300`}
    .icon {
      ${tw`ml-2 w-4`}
    }
  }
`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto shadow-lg`;
const TwoCol = styled.div`
  ${tw`flex justify-between max-w-screen-xl mx-auto`}
`;
const Navtabs = styled.div`
  ${tw`max-w-screen-xl mx-auto m-3 sticky`}
`;
const Navtabslink = tw.p`inline-flex items-center border-b-2 border-transparent hover:cursor-pointer hover:border-primary-700 font-semibold text-black`;
const Navline = styled.div`
  ${tw`text-primary-500`}
`;

let data = [
  {
    imageSrc: <Lock />,
  },
  {
    imageSrc: <SeamlessUser />,
  },
  {
    imageSrc: <Migration />,
  },
  {
    imageSrc: <APIs />,
  },
  {
    imageSrc: <Multichannel />,
  },
  {
    imageSrc: <SelfService />,
  },
  {
    imageSrc: <Recycle />,
  },
  {
    imageSrc: <Analytics />,
  },
  {
    imageSrc: <Scalability />,
  },
];

const ApplicationFramework = ({ title }) => {
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const divs = document.querySelectorAll(".div-class");
      let topDiv = null;
      let minTop = Infinity;

      divs.forEach((div) => {
        const { top } = div.getBoundingClientRect();
        if (top >= 0 && top < window.innerHeight && top < minTop) {
          minTop = top;
          topDiv = div.id;
        }
      });

      setActiveSection(topDiv);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.title = "Welcome to Iqura - Application-in-a-box";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Streamline your new application development and leverage our expertise and ready-made frameworks for faster enterprise application development. Our framework comprises cloud-ready .NET APIs with a JS-based responsive front-end UI along with comprehensive identity management using AWS Cognito. When time to market matters, we deliver. "
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      "Application framework, Application-in-a-box,Secure  Authentication, JWT-based Authentication,Authentication Token Management, Registration & Sign-on, Password Management, Roles and Claim Management, Email & Multi-factor authentication (MFA), CORS and API Security, AWS Secrets Implementation, Reliability &  Maintenance, Error Logging, Mobile Ready, Efficient Data Handling, Caching Mechanisms, Multi-language Support"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = "https://www.iqura.tech/what-we-do/application-framework";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const styles = `
.active {
  font-weight: semibold;
  color: #f56565;
  // color: #6415ff;
  // border-bottom: 1px solid #f56565;
}
`;

  let [current, setCurrent] = useState(0);

  let slidesData = [
    {
      image: framework,
      typeID: "element4_app",
      typedHead:
        "Get off the ground running with your new enterprise app with our robust framework and repository.",
      heading1: "Application -",
      heading2: "in-a-box",
      route: "/what-we-do/application-framework",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];

  const navigate = useNavigate();
  const navLinks = [
    <NavLinks key={1}>
      <NavLink onClick={() => navigate("/", { state: "whatwedo" })}>
        What we do
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "ourservices" })}>
        Services
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "techstack" })}>
        Techstack
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "whoweare" })}>
        Who we are
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "career" })}>
        Careers
      </NavLink>
      <NavLink onClick={() => navigate("/", { state: "contact" })}>
        Contact
      </NavLink>
    </NavLinks>,
  ];
  const childRef = useRef(null);
  const handleBreadCrumbClose = () => {
    if (childRef.current) {
      childRef.current.handleClick();
    }
  };

  const imgStyle = { width: "40px", height: "40px" };

  let ExpertiseData = [
    {
      imageSrc: <JSON style={imgStyle} />,
    },
    {
      imageSrc: <Fingerprint style={imgStyle} />,
    },
    {
      imageSrc: <SignOn style={imgStyle} />,
    },
    {
      imageSrc: <PassKey style={imgStyle} />,
    },
    {
      imageSrc: <Roles style={imgStyle} />,
    },
    {
      imageSrc: <EmailCheck style={imgStyle} />,
    },

    {
      imageSrc: <Lock style={imgStyle} />,
    },
    {
      imageSrc: <Amazon style={imgStyle} />,
    },
  ];

  let maintenanceImages = [
    {
      imageSrc: <LogError style={imgStyle} />,
    },
    {
      imageSrc: <Mobile style={imgStyle} />,
    },
    {
      imageSrc: <DataEfficient style={imgStyle} />,
    },
    {
      imageSrc: <Cache style={imgStyle} />,
    },
    {
      imageSrc: <MultiLanguage style={imgStyle} />,
    },
    {
      imageSrc: <SearchEngineOptimization style={imgStyle} />,
    },
  ];

  const ourExpertise = logoTextData.ourservices.ourexpertise.map(
    (item, index) => (
      <IconCard
        key={index}
        title={item.title}
        description={item.description}
        imageSrc={ExpertiseData[index].imageSrc}
      />
    )
  );

  const maintenance = logoTextData.ourservices.maintenance.map(
    (item, index) => (
      <IconCard
        key={index}
        title={item.title}
        description={item.description}
        imageSrc={maintenanceImages[index].imageSrc}
      />
    )
  );
  //   const packages = logoTextData.ourservices.packages.map((item, index) => (
  //     <IconCard
  //       key={index}
  //       title={item.title}
  //       description={item.description}
  //       imageSrc={ExpertiseData[index].imageSrc}
  //     />
  //   ));

  function handleNavbarScroll(id, value) {
    // setCurrentNav(id);
    let idList = ["authentication", "reliability"];

    for (let i = 0; i < idList.length; i++) {
      if (id != idList[i]) {
        document.getElementById(idList[i]).style.paddingTop = "0px";
      }
    }

    document.getElementById(id).style.paddingTop = value;
    var eleme = document.getElementById(id);
    eleme.scrollIntoView({
      behavior: "smooth",
    });
  }

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        let idList = [
          "authentication",
          "reliability",
          //   "packages",
        ];
        for (let i = 0; i < idList.length; i++) {
          document.getElementById(idList[i]).style.paddingTop = "0px";
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navLink = [
    {
      section: "Authentication",
      label: "Authentication",
      scrollTo: "authentication",
      width: `${window.innerWidth <= 425 ? 160 : 130}px`,
    },

    {
      section: "Reliability ",
      label: "Reliability",
      scrollTo: "reliability",
      width: `${window.innerWidth <= 425 ? 150 : 130}px`,
    },
    {
      section: "Techstack",
      label: "Techstack",
      scrollTo: "techstack",
      width: `${window.innerWidth <= 425 ? 80 : 60}px`,
    },
  ];

  const navLinksRendered = navLink.map((link) => (
    <Navtabslink
      style={{ backgroundColor: "#eef5ff" }}
      key={link.section}
      className={activeSection === link.scrollTo ? "active" : ""}
      onClick={() => handleNavbarScroll(link.scrollTo, link.width)}
    >
      {link.label}
    </Navtabslink>
  ));

  return (
    <>
      <Navbar className="shadow-md" />
      <ContainerNav>
        <OpacityOverlay />
        <HeroContainer>
          <StyledHeader links={navLinks} />
        </HeroContainer>
      </ContainerNav>
      <BreadCrumbs
        ref={childRef}
        title={"Application-in-a-box"}
        title1={"What we do"}
      />
      <ContactUsButton />
      <div className="overflow-hidden relative  ">
        <div
          className="flex transition-transform ease-out duration-300 "
          style={{
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {slides.map((s) => {
            return (
              <div className="z-22" style={{ width: "100%" }}>
                {s}
              </div>
            );
          })}
        </div>

        <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
          {slides.map((s, i) => {
            return (
              <div
                onClick={() => {
                  setCurrent(i);
                }}
              ></div>
            );
          })}
        </div>
      </div>
      <style>{styles}</style>
      <Container onClick={handleBreadCrumbClose}>
        <TwoCol>
          <WrapperDescription>
            <Description
              style={{
                backgroundColor: "white",
                marginTop: `${window.innerWidth <= 425 ? -140 : -210}px`,
                padding: "40px",
              }}
            >
              <ImageHeader
                imageHeaderData={imageHeader.Framework}
                imgsource={Framework}
              />
            </Description>
          </WrapperDescription>
        </TwoCol>
        <div>
          <Navtabs
            style={{
              top: "78px",
              zIndex: "2",
            }}
          >
            <div className="flex 	 justify-center lg:gap-12 gap-4 p-2  mx-2 mt-8 flex-wrap ">
              <div
                style={{ backgroundColor: "#eef5ff" }}
                className="flex shadow-md justify-center lg:gap-12 gap-4 p-2  px-10 flex-wrap "
              >
                {navLinksRendered}
              </div>
            </div>
          </Navtabs>

          <div id="authentication" className="div-class"></div>
          <Wrapper>
            <SubHeadings heading1="Secure" heading2="Authentication" />
          </Wrapper>

          <ThreeColumnContainer>{ourExpertise}</ThreeColumnContainer>

          <div id="reliability" className="div-class mt-5">
            <Wrapper>
              <SubHeadings heading1="Reliability &" heading2="Maintenance" />
              </Wrapper>
            <ThreeColumnContainer>{maintenance}</ThreeColumnContainer>
          </div>
          <div id="techstack" className="div-class mt-5">
          <Wrapper>
              <SubHeadings heading1="Our" heading2="Techstack" />
            <TechStack1 />
          </Wrapper>
          </div>
          <Footer />
        </div>
      </Container>
    </>
  );
};

export default ApplicationFramework;
